@if (loading$ | async) {

  <div class="global-progress">

    <div class="global-progress-bar"></div>

  </div>

}


<router-outlet></router-outlet>
